import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
    selector: 'page-palette',
    templateUrl: 'palette.html',
})


export class PalettePage {

    dynpal: boolean = false
    dynpal_auto: boolean = false
    custom_min: string
    custom_max: string

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        
    }

    ionViewDidLoad() {
        console.log('this.navParams.data: ', this.navParams.data);
        this.dynpal = this.navParams.data.dynpal
        this.dynpal_auto = this.navParams.data.dynpal_auto
        this.custom_min = parseFloat(this.navParams.data.custom_min).toFixed(1)
        this.custom_max = parseFloat(this.navParams.data.custom_max).toFixed(1)
    }

    changePalDyn(event: any) {
        this.dynpal = event;
        if (this.dynpal == false) this.dynpal_auto = false
        console.log("dynpal_auto: ", this.dynpal, this.dynpal_auto)
    }

    changePalMode(event: any) {
        this.dynpal_auto = event;
        console.log("palette_mode: ", this.dynpal, this.dynpal_auto)
    }

    closeModal() {
        this.navCtrl.first().dismiss(
            {
                dynpal: this.dynpal,
                dynpal_auto: this.dynpal_auto,
                custom_min: this.custom_min,
                custom_max: this.custom_max,

            }
        );
    }


}



// WEBPACK FOOTER //
// ./src/pages/palette/palette.ts